import styles from "./index.module.scss";
import AvatarC from "../avatar";
import { scrollToTop } from "../../../utils/const";
import { useNavigate } from "react-router-dom";
import { formatCurrency } from "../../../utils/utils";
import Like from "../like";
import { NavigatePropertyDetail } from "../../investor/amplitude";
import PriceDropTag from "../pricedrop-tag";

export default function MobileCard({ item, innerRef, status, loginType }: any) {
  const navigate = useNavigate();

  return (
    <div className={styles.card} ref={innerRef}>
      <div
        className={styles.box}
        onClick={() => {
          scrollToTop();
          if (loginType === "agent") {
            navigate(`/internal/${item?.id}`, {
              state: {
                propertyDetails: item,
                objPropertyDetails: item
              }
            });
          } else {
            NavigatePropertyDetail({
              propertyId: item?.id,
              propertySFID: item?.propertySFID,
              opportunitySFID: item?.opportunitySFID,
              pubPropertySFID: item?.pubPropertySFID,
              shareId: item?.shareKey,
              address: item?.address,
              bedRooms: item?.bedRooms,
              baths: item?.baths,
              sqft: item?.sqft,
              askingPrice: item?.askingPrice
            });
            navigate(`/external/${item?.shareKey}`, {
              state: {
                propertyDetails: item,
                objPropertyDetails: item
              }
            });
          }
        }}
      >
        <div className={styles.imgBox}>
          {/* eslint-disable-next-line jsx-a11y/alt-text */}
          <img
            src={item?.posterImage || "/images/default-property.jpg"}
            // onError={(e: any) => {
            //   e.target.src = "/images/default-property.jpg";
            //   e.target.alt = "Image not available";
            // }}
          />
          <div
            className={styles.Showing}
            style={{ background: status?.bgColor, color: status?.txtColor }}
          >
            {item?.status}
          </div>
          <div className={styles.like}>
            <Like
              loginType={loginType}
              propertyId={item.id}
              favCount={item.favCount}
              isMobile={true}
              objPropertyDetails={item}
            />
          </div>
        </div>
        <div className={styles.contentBox}>
          <div className={styles.addressWrap}>
            <div className={styles.address}>{item?.street}</div>
            <div className={styles.location}>
              {(item?.city && `${item?.city}, `) +
                item?.state +
                " " +
                item?.postalcode}
            </div>
          </div>
          <div className={styles.wrapUpper}>
            <div className={styles.priceWrap}>
              <div className={styles.priceTitle}>PRICE</div>
              <div className={styles.PriceValue}>
                {formatCurrency(item?.askingPrice, "USD", "en-US")}
              </div>
              <PriceDropTag
                type={loginType}
                priceDrop={item?.priceDrop}
                priceDropDate={item?.priceDropDate}
              />
            </div>
            {loginType === "agent" && (
              <>
                {item?.acquisitionAgent1?.name && (
                  <div className={styles.agentWrap}>
                    <AvatarC
                      // image="/images/mobile-agent.png"
                      label={`${item.acquisitionAgent1?.name?.slice(
                        0,
                        1
                      )}${item.acquisitionAgent1?.name
                        ?.split(" ")[1]
                        ?.slice(0, 1)}`}
                      shape="circle"
                    />
                    <div className={styles.agentTextWrap}>
                      <div className={styles.Agent}>Agent</div>
                      <div className={styles.AgentValue}>
                        {item?.acquisitionAgent1 &&
                          `${item.acquisitionAgent1?.name?.split(" ")?.[0]} ` +
                            item.acquisitionAgent1?.name?.split(" ")?.[1]}
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          {/* <div className={styles.bottomWrap}>
            <div className={styles.priceWrap}>
              <div className={styles.price}>Highest Offer</div>
              <div className={styles.priceValue}>
                {formatCurrency(item.offers)}
              </div>
            </div>
            <div className={styles.priceWrap}>
              <div className={styles.price}>Offer</div>
              <div className={styles.priceValue}>23</div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}
